import { Link } from 'react-router-dom';
import { appSetHref, documentHref } from '@/lib/chat-sources';
import type { DashboardChatSourcedAnswerResult } from '@shared/types/dashboard-chat';

/**
 * D1 — under an answer of the work chat: each [n] with what it cites (opens
 * the document or the page), then the cited sources that could not be read.
 */
export const SourcedAnswerSources = ({ result }: { result: DashboardChatSourcedAnswerResult }) => {
  if (!result.citations.length && !result.unread.length) return null;
  return (
    <ol className="mt-3 space-y-1.5 border-t border-domino-border pt-2 text-sm text-domino-inkSoft">
      {result.citations.map((citation) => (
        <li key={citation.n} className="flex gap-2">
          <span className="shrink-0 tabular-nums">[{citation.n}]</span>
          {citation.kind === 'document' ? (
            <span className="min-w-0">
              <Link to={documentHref(citation.documentId)} className="text-domino-aubergine hover:underline">
                {citation.title}
              </Link>
              {citation.excerpt && <span className="block truncate" title={citation.excerpt}>« {citation.excerpt} »</span>}
            </span>
          ) : citation.kind === 'account' ? (
            <Link to={`/threads/${citation.subjectId}`} className="min-w-0 truncate text-domino-aubergine hover:underline">
              {citation.title}
            </Link>
          ) : citation.kind === 'record_set' ? (
            <span className="min-w-0 truncate">
              <Link to={appSetHref(citation)} className="text-domino-aubergine hover:underline">
                {citation.title}
              </Link>
              <span> · {citation.app}</span>
            </span>
          ) : citation.kind === 'record' ? (
            <span className="min-w-0 truncate">
              <Link to={`/apps/${citation.appKey}/o/${citation.recordId}`} className="text-domino-aubergine hover:underline">
                {citation.title}
              </Link>
              <span> · {citation.app}</span>
            </span>
          ) : (
            <a href={citation.url} target="_blank" rel="noreferrer" className="min-w-0 truncate text-domino-aubergine hover:underline">
              {citation.title}
            </a>
          )}
        </li>
      ))}
      {result.unread.map((item) => (
        <li key={item.label} className="flex gap-2">
          <span className="shrink-0">—</span>
          <span className="min-w-0">{item.label} · {item.reason}</span>
        </li>
      ))}
    </ol>
  );
};
